import DetailsColumn from "./DetailsColumn";
import SelectButtonsWithMore from "../../select/SelectButtonsWithMore";
import React from "react";
import PerformanceAndSkillsScoreBar from "./PerformanceAndSkillsScoreBar";

class PerformanceAndSkillsScore extends DetailsColumn {
    state = {
        value: ''
    };

    renderBody = () => {
        return (
            <div className="performance-and-skills-score-body">
                {this.renderFilters()}
                {this.renderChart()}
            </div>
        );
    };

    renderChart = () => {
        const {data} = this.props;
        const {value} = this.state;

        let item = data.find(item => item.name === value);

        if (value.length === 0)
            item = data[0];

        let scoreBars = [];

        if (item)
            scoreBars = item.attributes;
        else
            return "No options to show!";

        return (
            <div className="values-container">
                <div className="chart">
                    {scoreBars.map((scoreBar) => <PerformanceAndSkillsScore.ScoreBar title={scoreBar.name} value={scoreBar.value}/>)}
                </div>
                {this.renderProgressValues()}
            </div>
        );
    };

    renderFilters = () => {
        const {data} = this.props;

        if (!data?.length)
            return "No options to show!";

        const selectButtonsOptions = data.map(item => ({label: item.name, value: item.name, key: item.name}));
        return (
            <div className="filter-container">
                <SelectButtonsWithMore className="w-100" color="secondary" limit={5} split secondary size="sm" options={selectButtonsOptions} defaultValue={selectButtonsOptions[0].value} onSelect={this.handleTableSelect}/>
            </div>
        );
    };

    renderProgressValues = () => {
        const values = [0, 20, 40, 60, 80, 100];
        return (
            <div className="progress-values">
                {values.map((item, index) => <span key={index}> {item} </span>)}
            </div>
        );
    };

    handleTableSelect = (event, option) => {
        const {value} = option;
        this.setState({
            value: value,
        });
    };

    static defaultProps = {
        headerTitle: "Performance and Skills Score"
    };

    getComponentClassName = () => 'performance-and-skills-score';
}

PerformanceAndSkillsScore.ScoreBar = PerformanceAndSkillsScoreBar;
export default PerformanceAndSkillsScore;
